/**
 * @license The MIT License (MIT)
 * @copyright Stanislav Kalashnik <darkpark.main@gmail.com>
 */

/* eslint no-path-concat: 0 */

'use strict';

var List = require('mag-component-list'),
    CheckBox = require('spa-component-checkbox'),
    counter = 0;


/**
 * Base radio list implementation
 *
 * @constructor
 * @extends List
 *
 * @param {Object} [config={}] init parameters (all inherited from the parent)
 */
function RadioList ( config ) {
    var self = this;

    /**
     * Checkbox group name
     *
     * @type {string}
     */
    this.group = 'group ' +  counter++;

    /**
     * Link to checked item
     *
     * @type {Element}
     */
    this.$checkedData = null;

    //config.className = 'radioList ' + (config.className || '');

    List.call(this, config);

    this.addListener('click:item', function ( event ) {
        var item = event.$item;

        item.checkBox.set(true);
        item.state = item.checkBox.value;
        item.data.state = item.checkBox.value;

        if ( self.$checkedData !== item.data ) {
            /**
             * Select element from list.
             *
             * @event
             *
             * @type {Object}
             * @property {Element} previous selected element
             * @property {Element} current selected element
             */
            self.emit('select', {
                $last: self.$checkedData,
                $curr: item
            });
            if ( self.$checkedData ) { self.$checkedData.state = false; }
            self.$checkedData = item.data;
        }
    });
}


RadioList.prototype = Object.create(List.prototype);
RadioList.prototype.constructor = RadioList;

// set component name
RadioList.prototype.name = 'mag-component-radio-list';

RadioList.prototype.group = 0;


/**
 * Default render function
 *
 * @param {Element} $item in list
 * @param {Array} data to render layout element
 * @param {string} [data.title] title of checkbox
 * @param {boolean} [data.state] state of checkbox: checked or not
 * @param {string} [data.value] special value of item
 */
RadioList.prototype.renderItemDefault = function ( $item, data ) {
    var table = document.createElement('table'),
        tr = document.createElement('tr'),
        td = document.createElement('td'),
        check = new CheckBox({
            group: this.group
        });

    $item.innerHTML = '';

    // set state with set function to prevent multiple true values
    if ( data.state ) {
        check.set(true);
        // set link to checked item
        this.$checkedData = data;
    }

    table.appendChild(tr);

    td.appendChild(check.$node);
    td.className = 'checkBoxWrapper';
    tr.appendChild(td);

    td = document.createElement('td');
    td.className = 'title';
    td.innerText = data.title || '';
    tr.appendChild(td);

    $item.checkBox = check;

    $item.state = check.value;
    $item.value = data.value;


    $item.appendChild(table);
};

// RadioList.prototype.setData = function ( config ) {
//     var i;
//
//     List.prototype.setData.call(this, config);
//
//     for ( i = 0; i < this.data.length; i++ ) {
//         if ( this.data[i].state ) {
//             this.$checkedData = this.data[i];
//             break;
//         }
//     }
//
// };

RadioList.prototype.renderItem = RadioList.prototype.renderItemDefault;


module.exports = RadioList;
